"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientPage/TextingSection.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);









var _consent = require('shared/services/consent');
var _classBuilder = require('shared/services/classBuilder'); var _classBuilder2 = _interopRequireDefault(_classBuilder);










var _smsDelivery = require('shared/services/smsDelivery');

var _components = require('web/screens/Directory/components');
var _ConsentSection = require('./ConsentSection');




















const rowKey = (row) => `${row.Shared ? 'shared-' : ''}${row.Reason}`

// "Texting · Not deliverable", then one line per reason with who/when and
// what clears it. Admins get Resubscribe on a staff opt-out, Unblock on an
// admin block and Clear on a number that can't receive texts; rows Twilio
// enforces only clear when the patient texts START.
const TextingSection = ({
  rows, isAdmin, nameOf, onMarkOptedOut, onBlock, onClear, isClearing, consent, onRecordConsent,
}) => {
  const deliverable = _smsDelivery.isSMSDeliverable.call(void 0, { SMSUndeliverable: rows })
  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', {
        className: _classBuilder2.default.call(void 0, 
          'directory-page--info-section--metadata-item',
          'directory-page--sms-state',
          !deliverable && 'directory-page--sms-state--undeliverable',
        ),
        'data-testid': "patient-sms-state", __self: this, __source: {fileName: _jsxFileName, lineNumber: 59}}

        , _react2.default.createElement('span', { className: "name", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}},  _smsDelivery.SMS_TEXTING_LABEL )
        , _react2.default.createElement('span', { className: "value", __self: this, __source: {fileName: _jsxFileName, lineNumber: 68}},  _smsDelivery.smsDeliverabilityLabel.call(void 0, { SMSUndeliverable: rows }) )
      )
      ,  !!rows.length && (
        _react2.default.createElement('ul', { className: "directory-page--sms-reasons", 'data-testid': "patient-sms-reasons", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
          ,  rows.map(row => {
            const view = _smsDelivery.describeSMSUndeliverableRow.call(void 0, row, { createdByName: nameOf(row.CreatedBy) })
            // In a consent org an admin can record that a contact who texted
            // STOP asked again (Resubscribe's "asked again" form).
            const isAskedAgainRow = !!consent && _consent.isTextedStop.call(void 0, row)
            const action = isAdmin
              ? (isAskedAgainRow ? 'ResubscribePatientSMS' : _smsDelivery.smsUndeliverableClearAction.call(void 0, row))
              : null
            const hint = isAskedAgainRow && !isAdmin
              ? _consent.CONSENT_ASK_ADMIN_ASKED_AGAIN_COPY
              : _smsDelivery.smsUndeliverableAskAdminCopy.call(void 0, row, isAdmin)
            return (
              _react2.default.createElement('li', { key: rowKey(row), className: "directory-page--sms-reasons--item", 'data-testid': "patient-sms-reason", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}}
                , _react2.default.createElement('div', { className: "directory-page--sms-reasons--text", __self: this, __source: {fileName: _jsxFileName, lineNumber: 85}}
                  , _react2.default.createElement('span', { className: "directory-page--sms-reasons--label", __self: this, __source: {fileName: _jsxFileName, lineNumber: 86}},  view.label )
                  ,  !!view.detail && _react2.default.createElement('span', { className: "directory-page--sms-reasons--detail", __self: this, __source: {fileName: _jsxFileName, lineNumber: 87}},  view.detail ) 
                  ,  !!view.note && _react2.default.createElement('span', { className: "directory-page--sms-reasons--note", __self: this, __source: {fileName: _jsxFileName, lineNumber: 88}},  `"${view.note}"` ) 
                  ,  !!view.clears && _react2.default.createElement('span', { className: "directory-page--sms-reasons--clears", __self: this, __source: {fileName: _jsxFileName, lineNumber: 89}},  view.clears ) 
                  ,  !!hint && _react2.default.createElement('span', { className: "directory-page--sms-reasons--clears", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}},  hint ) 
                )
                ,  action && (
                  _react2.default.createElement('button', {
                    type: "button",
                    className: "directory-page--sms-reasons--clear-btn",
                    disabled: isClearing,
                    onClick: () => onClear(action), __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}}

                    ,  isAskedAgainRow ? _consent.RECORD_ASKED_AGAIN_LABEL : _smsDelivery.smsUndeliverableClearLabel.call(void 0, action) 
                  )
                )
              )
            )
          })
        )
      )
      ,  consent && _react2.default.createElement(_ConsentSection.ConsentRow, { consent: consent, onRecord: onRecordConsent, __self: this, __source: {fileName: _jsxFileName, lineNumber: 107}} ) 
      ,  (onMarkOptedOut || onBlock) && (
        _react2.default.createElement('div', { className: "directory-page--sms-actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 109}}
          ,  onMarkOptedOut && (
            _react2.default.createElement(_components.InfoBtn, {
              label: _smsDelivery.SMS_MARK_OPTED_OUT_TITLE,
              onClick: onMarkOptedOut,
              iconSrc: "/assets/icons/alert-grey.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 111}}
            )
          )
          ,  onBlock && (
            _react2.default.createElement(_components.InfoBtn, {
              label: _smsDelivery.SMS_BLOCK_PATIENT_LABEL,
              onClick: onBlock,
              iconSrc: "/assets/icons/alert-orange.svg",
              theme: "danger", __self: this, __source: {fileName: _jsxFileName, lineNumber: 118}}
            )
          )
        )
      )
    )
  )
}

exports. default = _react.memo.call(void 0, TextingSection)
